luckyBetToggleButton = {};

luckyBetToggleButton.create = function () {
  var button = new PIXI.Container();

  button.basePath = arguments[0]['FQN'];

  button.toggleButton = undefined;

  button.luckyBetMessage = undefined;
  button._isPromotion = false;

  button.canPlaceBet = false;

  InputHelpers.addGenerics(button);
  button._flags.showLuckyBetActive = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  if (typeof arguments[0]['hitAreaPolygon'] !== 'undefined') {
    var polygon = arguments[0]['hitAreaPolygon'];
    var scaledPolygon = [];
    polygon.forEach(function (value, index) {
      scaledPolygon.push(value * resourceManager.selectedAssetResolution.scale);
    });
    button.hitArea = new PIXI.Polygon(scaledPolygon);

    if (Reflex.developerModeData.showButtonHitAreas) {
      button.graphics = new PIXI.Graphics();
      button.graphics.beginFill(0xff0008);
      button.graphics.lineStyle(4, 0xff0008, 1);
      button.graphics.drawPolygon(scaledPolygon);
      button.graphics.endFill();
      button.graphics.alpha = 0.5;
      button.addChild(button.graphics);
    }
  }

  button.canShow = function () {
    return !freespins.inFreespins && this._flags.platformVisible;
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;
    const goldenbetStakes = this.gameConfig.data.slotConfig.gameModes.LUCKYBET_BUY.coinSizes;
    const baseStake = resourceManager.getController('stakeController').BaseStake / 50;

    const isCurrentBetAllowed = goldenbetStakes.includes(baseStake);
    button.canPlaceBet = isCurrentBetAllowed;

    if (!this._flags.modal.active) {
      let popUpsOpen = false;
      let autoplay = resourceManager.get('autoplayContainer:autoplayBacker');
      if (autoplay.visible) popUpsOpen = true;

      let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');
      if (buyBonusPopUp.visible) popUpsOpen = true;

      if (popUpsOpen) messageBus.postImmediate('game:modal', { reason: 'popups are open' });
    }

    var allow =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      this._flags.platformEnabled &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    button.alpha = allow ? 1 : 0.5;

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet;
  };

  button.onConfig = function (config) {
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;

    this.gameConfig = config;
  };

  button.onGameControllerStartGame = function () {
    if (button.outerFadeTimer) {
      timerManager.stop(button.outerFadeTimer, true);
    }
  };

  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe('spinner:GameConfigEvent', function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe('spinner:GameConfigEvent', button.onConfig.bind(button));
    messageBus.subscribe('gameController:startGame', button.onGameControllerStartGame.bind(button));
    messageBus.subscribe('common:PromotionStarted', button.promotionStarted.bind(button));
    messageBus.subscribe('common:PromotionEnded', button.promotionEnded.bind(button));
  };

  button.onLayoutComplete = function () {
    button.luckyBetMessage = resourceManager.get(`extraButtonsContainer:luckyBetMessage`);
    button.animParent = resourceManager.get(`${button.basePath}`);

    // create here on top of button
    button.luckyBetAnim = resourceManager.get(`extraButtonsContainer:luckyBetToggleButton:luckyBetAnim`);
    button.luckyBetAnim.gotoAndStop(0);
    button.luckyBetAnim.visible = true;

    button.toggleButton = resourceManager.get(`extraButtonsContainer:luckyBetToggleButton:button`);
    button.toggleButton.alpha = 0;

    button.mousedown = button.touchstart = () => {
      if (button.toggleButton.interactive) {
        button.toggleButton.mousedown();
      }
    };
    button.interactive = true;

    button.luckyBetMessage.alpha = 0.0;

    button.innerFadeTimer = undefined;
    button.outerFadeTimer = undefined;
  };

  button.showButton = function () {
    if (this.canShow() && this._flags.platformVisible) {
      if (!button._flags.showLuckyBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
      this.visible = true;
      button.luckyBetAnim.renderable = true;
    } else {
      if (!this._flags.platformVisible) {
        this.button.visible = false;
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = false;
        this.visible = false;
      } else {
        this.visible = false;
        this.button.visible = false;
      }
    }
  };

  button.hideButton = function () {
    this.button.visible = false;
    button.luckyBetAnim.renderable = false;
  };

  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable lucky bet
    button._flags.showLuckyBetActive = false;
    button.cancelLuckyBet();
  };

  button.cancelLuckyBet = function () {
    if (button.luckyBetMessage !== undefined) {
      button.luckyBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }

      button.luckyBetAnim.gotoAndStop(0);

      gameData.encoreEnabled = false;

      button.handleStakeChange(true);
    }
  };

  button.handleStakeChange = function (broadcast) {
    let bpl = resourceManager.getController('stakeController').BaseStake / 20;
    let luckyBetEnabled = gameData.encoreEnabled;
    resourceManager.getController('stakeController').setStakeMultiplier(luckyBetEnabled ? Globals.GB_MULTIPLIER : 1);
    game.changeStake(
      resourceManager.getController('stakeController').BaseStake * (luckyBetEnabled ? Globals.GB_MULTIPLIER : 1),
      bpl
    );

    if (broadcast) {
      resourceManager.getController('stakeController').broadcastCurrentStake();
    }
  };

  button.setRecovery = function () {
    // only called when we are recovering the game to set the game as lucky bet active
    button._flags.showLuckyBetActive = true;
    gameData.encoreEnabled = true;
    button.handleStakeChange(true);
    button.luckyBetAnim.gotoAndStop(19);
  };

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.onPressedCallback = function () {
    button._flags.showLuckyBetActive = !button._flags.showLuckyBetActive;

    if (button._flags.showLuckyBetActive) {
      messageBus.postImmediate('game:modal', { reason: 'goldenbetEnabled' });
      if (button.luckyBetMessage !== undefined) {
        button.luckyBetMessage.alpha = 1.0;
        button.outerFadeTimer = timerManager.addTimer(2000, undefined, function () {
          button.outerFadeTimer = null;
          button.innerFadeTimer = timerManager.addTimer(
            400,
            function (progress) {
              button.luckyBetMessage.alpha = 1 - progress;
            },
            function () {
              button.luckyBetMessage.alpha = 0.0;
              button.innerFadeTimer = null;
            }
          );
        });

        resourceManager.get('meterContainer:winnings').visible = false;
        gameData.winningsMeter.set(0);

        button.luckyBetAnim.gotoAndPlay(0);

        soundManager.play('activateGoldenBet');

        gameData.encoreEnabled = true;
        button.handleStakeChange(true);
      }
    } else {
      button.cancelLuckyBet();
      if (button.luckyBetMessage !== undefined) {
        soundManager.play('cancelGoldenBet');
      }
    }
  };

  return button;
};

luckyBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

luckyBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'luckyBetToggleButton',
  luckyBetToggleButton.create,
  luckyBetToggleButton.initialise,
  luckyBetToggleButton.getFilesRequired
);
